module.exports = __webpack_public_path__ + "static/media/rajecke2.e10993d4.jpeg";